export default __webpack_public_path__ + "static/media/FAIRLogo2020-blue.38a9edde.svg";